import { pluck } from 'ramda'

export const pluckIds = pluck('id')
